import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {TeamMembersComponent} from './team-members.component';
import {ActionPointListModule} from '../action-point-list/action-point-list.module';
import {FormsModule} from '@angular/forms';
import {TranslateDirective, TranslatePipe} from '@ngx-translate/core';


@NgModule({
  declarations: [TeamMembersComponent],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ActionPointListModule,
    TranslatePipe,
    TranslateDirective
  ],
  exports: [
    TeamMembersComponent
  ]
})
export class TeamMembersModule {
}
